<template>
  <div>
    <div class="card container my-3 my-md-5">
      <div class="card-body" ref="pdfContent">
        <h4 class="card-title text-center">{{title}}</h4>
        <b-table :items="shipments" :fields="fields" :bordered="true" small id="test">
        </b-table>
        Anzahl Sendungen: {{ shipments.length }}
        <div class="mt-4">
          Ich bestätige die angegebenen Sendungen entgegengenommen zu haben.<br>
          <div class="mt-4">_________________<br>
          <small>DHL Mitarbeiter</small></div>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-5">
        <div class="d-flex ml-4 mb-2">
          <label for="pickupDate" class="my-auto mr-3">Abholdatum: </label>
          <b-input-group class="">
            <b-form-input
              id="pickupDate"
              v-model="formattedPickupDate"
              type="text"
              placeholder=""
              autocomplete="off"
              disabled
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="pickupDate"
                button-only
                right
                start-weekday="1"
                aria-controls="example-input"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </div>
        <b-btn variant="primary" class="mb-2 mr-3" @click="createDailyClosing">Abschluss erstellen</b-btn>
      </div>
    </div>
  </div>
</template>
<script>
import html2pdf from 'html2pdf.js'
import moment from 'moment';

export default {
  props: ['passedShipments'],
  data(){
    return {
      fields: [
        { key: "shippingId",    label: "Sendungsnummer" },
        { key: "lastName",      label: "Empfänger" },
        { key: "marketOrderId", label: "MarketOrderId" }
      ],
      shipments: [],
      pickupDate: null,
      title: 'DHL Express Tagesabschluss',
    }
  },
  mounted(){
    this.shipments = this.passedShipments;
  },
  computed:{
    formattedPickupDate(){
      if(this.pickupDate === null) return;
      return moment(this.pickupDate, "YYYY-MM-DD").format('DD.MM.YYYY')
    }
  },
  methods:{
    createDailyClosing(){
      if(this.pickupDate === null){
        alert('Abholdatum bitte angeben');
        return;
      }
      
      axios.post('/dhlexp/pickup', {pickupDate: this.pickupDate})
      .then( res => { console.log(res.data); this.generatePDF(); })
      .catch( err => {console.log(err); });
    },

    generatePDF(){
      let currentDate = moment().format("DD.MM.YYYY");
      let pdfOptions = {
        margin: 7,
        filename: 'DHL_Express_Versandliste-'+currentDate+'.pdf',
        image: {type: 'jpgeg', quality: 0.98 },
        html2canvas: { unit: 'mm', format: 'a4', orientation: 'potrait'},
        pagebreak: {mode: 'css' },
      };
      this.title = 'DHL Express Versandliste ' + currentDate;
      this.printToggle = true;
      const pdfInstance =  html2pdf().from(this.$refs.pdfContent).set(pdfOptions).outputPdf()
      .then(()=>{this.title = "DHL Express Abschluss"; this.printToggle = false;});
      pdfInstance.save();
      
    }
  }
}
</script>
<style>
tr {
  page-break-after: auto!important;
  page-break-inside: avoid!important;
    
}

</style>